import { isFunction, noop } from 'lodash-es';

import { SAGA_ACTION, CANCEL } from './innerActionSymbol';

export const wrapSagaDispatch = (dispatch) => (action) => {
	action[SAGA_ACTION] = true;
	return dispatch(action);
};

export const getMetaInfo = (fn) => {
	return {
		name: fn.name || 'anonymous',
	};
};

export const isIterator = (it) => {
	return it && isFunction(it.next) && isFunction(it.throw);
};

export const deferred = () => {
	const _deferred = {};
	_deferred.promise = new Promise((resolve, reject) => {
		_deferred.resolve = resolve;
		_deferred.reject = reject;
	});

	return _deferred;
};

export const isPromise = (p) => {
	return p && isFunction(p.then);
};

export const resolvePromise = (promise, cb) => {
	const cancelPromise = promise[CANCEL];
	if (isFunction(cancelPromise)) {
		cb.cancel = cancelPromise;
	}
	promise.then(cb, (error) => {
		cb(error, true);
	});
};

/**
 Used to track a parent task and its forks
 In the fork model, forked tasks are attached by default to their parent
 We model this using the concept of Parent task && main Task
 main task is the main flow of the current Generator, the parent tasks is the
 aggregation of the main tasks + all its forked tasks.
 Thus the whole model represents an execution tree with multiple branches (vs the
 linear execution tree in sequential (non parallel) programming)
 A parent tasks has the following semantics
 - It completes if all its forks either complete or all cancelled
 - If it's cancelled, all forks are cancelled as well
 - It aborts if any uncaught error bubbles up from forks
 - If it completes, the return value is the one returned by the main task
 **/
const removeItem = (array, item) => {
	let idx = array.indexOf(item);
	if (idx > -1) {
		array.splice(idx, 1);
	}
};
export const forkQueue = (mainTask, onAbort, cont) => {
	let tasks = [];
	let result;
	let completed = false;

	addTask(mainTask);

	const getTasks = () => tasks;

	function addTask(task) {
		tasks.push(task);

		task.cont = (res, isErr) => {
			if (completed) {
				return;
			}
			removeItem(tasks, task);
			task.cont = noop;
			if (isErr) {
				abort(res);
			} else {
				if (task === mainTask) {
					result = res;
				}
				if (!tasks.length) {
					completed = true;
					cont(result);
				}
			}
		};
	}
	function abort(err) {
		onAbort();
		cancelAll();
		cont(err, true);
	}
	function cancelAll() {
		if (completed) {
			return;
		}
		completed = true;
		tasks.forEach((t) => {
			t.cont = noop;
			t.cancel();
		});
		tasks = [];
	}
	return {
		addTask,
		cancelAll,
		abort,
		getTasks,
	};
};
